import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { TOKEN_KEY } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Cake, Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) api.get("/auth/me").then((r) => { if (r.data.authenticated) nav("/"); }).catch(() => {});
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) { toast.error("Enter your username and password"); return; }
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { username, password });
      localStorage.setItem(TOKEN_KEY, r.data.token);
      toast.success("Welcome back!");
      nav("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="dark min-h-screen bg-background text-foreground flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-primary flex items-center justify-center pulse-ring mb-4">
            <Cake className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-2xl font-heading font-800 tracking-tight">Sprinkle Pancake Bot</h1>
          <p className="text-sm text-muted-foreground mt-1">Sign in to your control center</p>
        </div>

        <form onSubmit={submit} className="bg-[#0a0a0a] border border-white/10 rounded-2xl p-6 space-y-4">
          <div>
            <Label className="text-xs">Username</Label>
            <Input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="your username" className="bg-secondary border-white/10 mt-1" autoFocus data-testid="login-username" />
          </div>
          <div>
            <Label className="text-xs">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="bg-secondary border-white/10 mt-1" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-primary hover:bg-primary/90 rounded-lg" data-testid="login-submit">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Lock className="w-4 h-4 mr-2" />}
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="text-center text-[11px] text-muted-foreground mt-4">Private dashboard — authorized access only.</p>
      </div>
    </div>
  );
}
